module.exports = __webpack_public_path__ + "img/DSC_1117.eeedd593.jpg";